<template>
    <BreadCrumb PageTitle="Liste des pays" />

  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    

    export default defineComponent({
      name: "ListePaysPage",
      components: {
        BreadCrumb,
   
      },
    });
  </script>